import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { StaticDevicesFilters } from '@/api/routes/static-devices/types';
import smartSort from '@/utils/smartSort';

import { fetchStaticDevicesFilters } from './actionCreators';
import { staticDevicesFilters } from './mocks';

interface InitialState {
  staticDevicesFilters: StaticDevicesFilters,
  isLoading: boolean,
  error: string,
}

const initialState: InitialState = {
  staticDevicesFilters,
  isLoading: false,
  error: '',
};

export const staticDevicesFiltersSlice = createSlice({
  name: 'staticDevicesFilters',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase<any, PayloadAction<StaticDevicesFilters>>(
      fetchStaticDevicesFilters.fulfilled,
      (state, action) => {
        state.isLoading = false;
        state.error = '';
        state.staticDevicesFilters = {
          tag: action.payload.tag.sort(smartSort),
          org: action.payload.org,
          adv: action.payload.adv,
          profile: action.payload.profile,
          park: action.payload.park,
          operator: action.payload.operator,
          device: action.payload.device,
        };
      },
    );
    builder.addCase(
      fetchStaticDevicesFilters.pending,
      (state) => {
        state.isLoading = true;
      },
    );
    builder.addCase<any, PayloadAction<string>>(
      fetchStaticDevicesFilters.rejected,
      (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      },
    );
  },
});

export default staticDevicesFiltersSlice.reducer;
